module.exports = __webpack_public_path__ + "static/img/7.ddc980a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/zh/7.png
// module id = Vby6
// module chunks = 0